import { Candidatura } from '../../../types';
import axiosInstance from '../../api/axiosConfig';
import { getApiBaseUrl } from '../../baseUrl';

const PATH_V1_CANDIDATURA = "/candidaturas";

export const buscarCandidaturasPorCandidato = async (candidatoId: number): Promise<Candidatura[]> => {
  try {
    const apiUrl = getApiBaseUrl();
    const response = await axiosInstance.get(`${apiUrl}${PATH_V1_CANDIDATURA}/candidato/${candidatoId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cadastrarCandidatura = async (candidatura: Partial<Candidatura>) => {
  try {
    const apiUrl = getApiBaseUrl();
    const response = await axiosInstance.post(`${apiUrl}${PATH_V1_CANDIDATURA}`, candidatura);
    return response;
  } catch (error) {
    console.error('Service - erro ao cadastrar candidatura:', error);
    throw error;
  }
};

export const removerCandidaturasPorCandidato = async (candidatoId: number) => {
  try {
    // Primeiro, tentar buscar as candidaturas existentes
    const candidaturasExistentes = await buscarCandidaturasPorCandidato(candidatoId);

    if (candidaturasExistentes.length === 0) {
      return { data: { message: 'Nenhuma candidatura para remover' } };
    }
    
    // Tentar endpoint específico primeiro
    try {
      const apiUrl = getApiBaseUrl();
      const response = await axiosInstance.delete(`${apiUrl}${PATH_V1_CANDIDATURA}/candidato/${candidatoId}/all`);
      return response;
    } catch (endpointError) {
      console.warn('Endpoint específico falhou, tentando remoção individual:', endpointError);

      // Fallback: remover candidaturas individualmente
      const apiUrl = getApiBaseUrl();
      const removePromises = candidaturasExistentes.map(candidatura =>
        axiosInstance.delete(`${apiUrl}${PATH_V1_CANDIDATURA}/${candidatura.id}`)
        .catch((err: unknown) => {
          console.warn(`Erro ao remover candidatura ${candidatura.id}:`, err);
          return null;
        })
      );
      
      const results = await Promise.allSettled(removePromises);
      const sucessos = results.filter(r => r.status === 'fulfilled' && r.value !== null).length;
      
      return { 
        data: { 
          message: `${sucessos}/${candidaturasExistentes.length} candidaturas removidas`,
          removed: sucessos,
          total: candidaturasExistentes.length
        } 
      };
    }
  } catch (error) {
    console.error('Service - erro ao remover candidaturas do candidato:', error);
    throw error;
  }
}; 